const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSynchronize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m506.246 83.718-96-80c-4.768-4-11.392-4.832-17.024-2.208a16.02 16.02 0 0 0-9.216 14.496v48h-320c-35.296 0-64 28.736-64 64v238.848l64-53.344V128.006h320v48a16.02 16.02 0 0 0 9.216 14.496c5.632 2.624 12.256 1.792 17.024-2.208l96-80c3.68-3.04 5.76-7.52 5.76-12.288 0-4.768-2.08-9.248-5.76-12.288Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(.03906 0 0 .03906 10 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.006 198.502v185.504h-320v-48a16.02 16.02 0 0 0-9.216-14.496c-5.632-2.624-12.256-1.792-17.024 2.208l-96 80c-3.68 3.04-5.76 7.52-5.76 12.288 0 4.768 2.08 9.248 5.76 12.288l96 80c4.768 4 11.392 4.832 17.024 2.208a16.02 16.02 0 0 0 9.216-14.496v-48h320c35.296 0 64-28.704 64-64V145.158l-64 53.344Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(.03906 0 0 .03906 10 10)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m506.246 83.718-96-80c-4.768-4-11.392-4.832-17.024-2.208a16.02 16.02 0 0 0-9.216 14.496v48h-320c-35.296 0-64 28.736-64 64v238.848l64-53.344V128.006h320v48a16.02 16.02 0 0 0 9.216 14.496c5.632 2.624 12.256 1.792 17.024-2.208l96-80c3.68-3.04 5.76-7.52 5.76-12.288 0-4.768-2.08-9.248-5.76-12.288Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(.03906 0 0 .03906 50 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.006 198.502v185.504h-320v-48a16.02 16.02 0 0 0-9.216-14.496c-5.632-2.624-12.256-1.792-17.024 2.208l-96 80c-3.68 3.04-5.76 7.52-5.76 12.288 0 4.768 2.08 9.248 5.76 12.288l96 80c4.768 4 11.392 4.832 17.024 2.208a16.02 16.02 0 0 0 9.216-14.496v-48h320c35.296 0 64-28.704 64-64V145.158l-64 53.344Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(.03906 0 0 .03906 50 10)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynchronize);
export default __webpack_public_path__ + "static/media/synchronize.453307c500f86419923c37f0ab0fc2e2.svg";
export { ForwardRef as ReactComponent };